<template>
    <div class="contact_us_box">
        <div class="contact_us_wrap">
            <h2>CONTACT US</h2>
            <div class="line_bor"></div>
            <b-row class="bor_b">
                <!-- <b-col class="mt-1 bor_r border_b" sm="12" md="6" xl="6">
                    <div class="img_box">
                        <img class="img_icon" src="@/assets/imgs/home/phone_icon.png" alt="">
                        <div class="right_box">
                            <div class="h_4">Call Us</div>
                            <div class="t_txt">Office 86-21-22001802</div>
                        </div>
                    </div>
                </b-col> -->
                <b-col class=" mt-1 border_b" sm="12" md="6" xl="6">
                    <div class="img_box">
                        <img class="img_icon" src="@/assets/imgs/home/email_icon.png" alt="">
                        <div class="right_box">
                            <div class="h_4">Our Email</div>
                            <div class="t_txt">Have a video or message for us? Send it to:  shanghaieye@smg.cn</div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="mt-1 bor_r border_b" sm="12" md="6" xl="6">
                    <div class="img_box">
                        <img class="img_icon" src="@/assets/imgs/home/adver_icon.png" alt="">
                        <div class="right_box">
                            <div class="h_4">Advertising</div>
                            <div class="t_txt">Tel:86-21-22001802</div>
                            <div class="t_txt">Email: shanghaieye@smg.cn</div>
                        </div>
                    </div>
                </b-col>
                <b-col class=" mt-1 border_b" sm="12" md="6" xl="6">
                    <div class="img_box">
                        <img class="img_icon" src="@/assets/imgs/home/address_icon.png" alt="">
                        <div class="right_box">
                            <div class="h_4">Our Address</div>
                            <div class="t_txt">No. 298 Wei Hai Road Floor 16, SMG Building, Jing An District, </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from "@/components/common/layout/Footer.vue";
    export default {
        components: {
            Footer
        },
        mounted(){
            document.title = 'Contact | ShanghaiEye';
        },
    }
</script>

<style lang="less" scoped>
    .contact_us_box{
        .contact_us_wrap{
            width: 70%;
            margin: 0 auto 150px;
            .bor_b{
                padding-bottom: 60px;
                margin-bottom: 30px;
                border-bottom: 1px solid #ccc;
            }
            .line_bor{
                height: 4px;
                border-top: 1px solid #ccc;
                border-bottom: 1px solid #ccc;
                margin-bottom: 0.6rem;

            }
            h2{
                line-height: 1.2;
                font-family:FranklinGothic-Demi, sans-serif !important;
                letter-spacing: .05em;
                font-size: 40px;
                font-weight: bold;
                text-align: center;
                padding-top: 40px;
                padding-bottom: 20px;
                // border-bottom: 3px solid #ccc;
                margin-bottom: 0;
            }
            .bor_r{
                // border-right:1px solid #CCCCCC;
            }
            .img_box{
                display: flex;
                align-items: flex-start;
                .img_icon{
                    // width: 90px;
                    // height:90px;
                    width: 1.5rem;
                    height: 1.5rem;
                    margin-right: 30px;
                }
                .right_box{
                    flex: 1;
                    padding-top: 11px;
                    font-size:22px;
                    font-family:FranklinGothic-Demi;
                    font-weight:400;
                    color:#333333;
                    line-height:30px;
                    font-weight: bold;
                }
                .t_txt{
                    font-size:14px;
                    font-family:Open Sans;
                    font-weight:400;
                    color:#333333;
                    line-height:20px;
                }
            }
        }
    }
    @media screen and (max-width: 768px) {
        .contact_us_box{
            .contact_us_wrap{
                width: 85%;
                margin: 0 auto 30px;
                h2{
                    font-size: 30px;
                    margin-left: -15px;
                    margin-right: -15px;
                }
                .line_bor{
                    margin-left: -15px;
                    margin-right: -15px;
                }
                .bor_b{
                    margin-bottom: 0px;
                    border-bottom:none;
                    padding-bottom: 0px;
                }
                .bor_r{
                    border-right:none;
                }
                .border_b{
                    padding-bottom:0.43rem;
                    border-bottom:2px solid #EBEBEB;
                    margin-bottom:0.48rem;
                }
                .img_box{
                    .right_box{
                        padding-top: 0;
                    }
                }
            }
        }
        
    }
</style>